import { format } from 'date-fns';
import { Injectable } from '@angular/core';
import { PreferencesService } from '../preference/preferences.service';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { PreferenceTable } from 'src/app/models/preferences/preference.model';

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {
  private recentRoutes: { url: string; dateTimeVisited: string }[] = [];
  private excludedRoutes: string[] = [
    '/',
    '/qa',
    '/login',
    '/start',
    '/account',
    '/support',
    '/soporte',
    '/express-support',
    '/soporte-expres',
    '/transaction'
  ];
  private currentUrl: string;
  preferenceKey = 'historyList_view';
  localStoragePreferenceKey = 'historyListPreferences';
  preferences: PreferenceTable = {} as PreferenceTable;

  constructor(
    private router: Router,
    public readonly preferencesService: PreferencesService
  ) {
    this.router.events.subscribe((event) => {
      const url = this.router.url.split('?'[0])[0];
      const currentUrl = this.currentUrl?.split('?'[0])[0];

      if (url === currentUrl) {
        return;
      }

      if (event instanceof NavigationStart) {
        this.currentUrl = url;
        if (!this.shouldExcludeRoute(this.currentUrl)) {
          this.addToRecentRoutes(this.currentUrl);
        }
      }

      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        if (!this.shouldExcludeRoute(this.currentUrl)) {
          this.addToRecentRoutes(this.currentUrl);
        }
      }
    });
  }

  // method that returns an array of urls, containing information about recent paths and time elapsed since they were visited

  getRecentRoutes(): { url: string; dateTimeVisited: string }[] {
    return this.recentRoutes.map((route) => {
      const dateTimeVisited: any[] = route.dateTimeVisited
        .toLocaleString()
        .split(',');
      const session = dateTimeVisited.join('');
      return { url: route.url, dateTimeVisited: session };
    });
  }

  /* This method adds a URL to a list of recent paths, ensuring that there are no duplicates,
      limiting the list to 10 items and updating storage preferences. */
  async addToRecentRoutes(url: string) {
    const listPreferences = await this.preferencesService.getPreferenceByView(
      this.preferenceKey,
      this.localStoragePreferenceKey
    );

    const urlsList = listPreferences.filter(
      (preference) => url !== preference.url
    );
    const dateTimeVisited = format(new Date(), 'dd/MM/yyyy HH:mm:ss');
    const newUrls = { url, dateTimeVisited: dateTimeVisited };
    urlsList.unshift(newUrls);
    if (urlsList.length > 10) {
      urlsList.pop();
    }

    this.preferencesService.savePreferenceByView(
      this.preferenceKey,
      this.localStoragePreferenceKey,
      urlsList
    );
  }

  // method to check if a route should be excluded according to the defined routes
  private shouldExcludeRoute(url: string): boolean {
    return this.excludedRoutes.some((excludedRoute) => {
      if (url === excludedRoute) {
        return true;
      }

      return (
        url.startsWith(excludedRoute + '/') ||
        url.startsWith(excludedRoute + '?')
      );
    });
  }
}
